/* eslint-disable max-len */
import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

const useStyles = makeStyles(() => ({
  root: {
    width: '88px',
    height: '88px',
  },
}));

export default function SuccessModalIcon({ className }) {
  const classes = useStyles();
  return (
    <SvgIcon viewBox='0 0 88 88' className={classnames(classes.root, className)}>
      <path d="M37.9346 51.8L28.618 42.4833C27.8235 41.6888 26.8124 41.2916 25.5846 41.2916C24.3569 41.2916 23.3457 41.6888 22.5513 42.4833C21.7569 43.2777 21.3596 44.2888 21.3596 45.5166C21.3596 46.7444 21.7569 47.7555 22.5513 48.55L34.9013 60.9C35.768 61.7666 36.7791 62.2 37.9346 62.2C39.0902 62.2 40.1013 61.7666 40.968 60.9L65.4513 36.4166C66.2457 35.6222 66.643 34.6111 66.643 33.3833C66.643 32.1555 66.2457 31.1444 65.4513 30.35C64.6569 29.5555 63.6457 29.1583 62.418 29.1583C61.1902 29.1583 60.1791 29.5555 59.3846 30.35L37.9346 51.8ZM44.0013 87.3333C38.0069 87.3333 32.3735 86.1958 27.1013 83.9208C21.8291 81.6458 17.243 78.5583 13.343 74.6583C9.44297 70.7583 6.35547 66.1722 4.08047 60.9C1.80547 55.6277 0.667969 49.9944 0.667969 44C0.667969 38.0055 1.80547 32.3722 4.08047 27.1C6.35547 21.8277 9.44297 17.2416 13.343 13.3416C17.243 9.44163 21.8291 6.35413 27.1013 4.07913C32.3735 1.80413 38.0069 0.666626 44.0013 0.666626C49.9957 0.666626 55.6291 1.80413 60.9013 4.07913C66.1735 6.35413 70.7596 9.44163 74.6596 13.3416C78.5596 17.2416 81.6471 21.8277 83.9221 27.1C86.1971 32.3722 87.3346 38.0055 87.3346 44C87.3346 49.9944 86.1971 55.6277 83.9221 60.9C81.6471 66.1722 78.5596 70.7583 74.6596 74.6583C70.7596 78.5583 66.1735 81.6458 60.9013 83.9208C55.6291 86.1958 49.9957 87.3333 44.0013 87.3333Z" fill="#017929"/>
    </SvgIcon>
  );
}
